import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const dashboardApi = createApi({
    reducerPath: "dashboard",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['dashboard'],
    endpoints: (builder) => ({
        getUser: builder.query({
            query: ({current_year}) => ({
                url: `admin/dashboard?recent_limit=${6}&current_year=${current_year}`,
                method: "GET",
            }),
            transformResponse: (res) => res.data,
            providesTags: ['dashboard'],
        }),
    })
});

export const { useGetUserQuery } = dashboardApi;